import videojs from 'video.js';

const registerPlugin = videojs.registerPlugin || videojs.plugin;

// Register the plugin with video.js.
registerPlugin('replay', function() {
	let player = this;
  let is_ended = false;
  let is_roll = false; // есть ли реклама
	player.ready(() => {
		player.on('ended', () => {
      player.addClass('vjs-replay');
      // после завершения рекламы вызывается событие player.ended потом vast.adBlockEnd
      // чтобы не появилась кнопка replay после рекламы pre_roll нужно делать ранний выход
      if (is_roll) return;
      let playbackRateMenuButton = player.controlBar.getChild('playbackRateMenuButton');
      if (playbackRateMenuButton) {
        player.playbackRate(player.defaultPlaybackRate());
        playbackRateMenuButton.updateLabel();
      }
      is_ended = true;
      setTimeout(() => {
        player.autoplay(false);
        player.src(player.currentSrc());
      }, 1)
		});
    player.on('vast.adBlockStart', () => {
      player.removeClass('vjs-replay');
      // в начале рекламы флаг поднимается
      is_roll = true;
    });
    player.on('vast.adBlockEnd', () => {
      player.removeClass('vjs-replay');
      // при окончании рекламы флаг опускается
      is_roll = false;
      if (is_ended) {
        player.addClass('vjs-replay');
        let playbackRateMenuButton = player.controlBar.getChild('playbackRateMenuButton');
        if (playbackRateMenuButton) {
          player.playbackRate(player.defaultPlaybackRate());
          playbackRateMenuButton.updateLabel();
        }
      }
    });
	});
});
